/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-07-07 16:28:07
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-11-07 14:20:18
 * @FilePath: \ui\src\api\rag.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import http from './index.ts'
export interface Result<T> {
  code: number
  data: T
  message: string
}
export const getRags = () => {
  return http.get('/rag/list')
}
